import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {isDefined} from '@aviary/store/common/typing.helpers';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'px-combined-balance-table-row',
  templateUrl: './combined-balance-table-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe, TruncateDirective]
})
export class CombinedBalanceTableRowComponent {
  @Input() public description?: string;
  @Input() public title?: string;
  @Input() public transactionId?: string;
  @Input() public date?: string;
  @Input() public amount?: string;
  protected readonly isDefined = isDefined;
}
